import CreateNewClaimModal from "./CreateNewClaimModal";

export default CreateNewClaimModal;
